/**
 * проверка соответствия размеру экрана
 * @example checkMediaQuery('(min-width: 1920px)')
 */
export const checkMediaQuery = (query: string) =>
  globalThis?.matchMedia?.(query).matches ?? true;
